export default __webpack_public_path__ + "fonts/axure_img.4cd3c9178a3db025002abd0cfb8a5ae6.png";